import { Controller } from 'react-hook-form'
import { FileText } from 'lucide-react'
import { CKEditor4 } from '@/components/editor/CKEditor4'
import companyFormStyles from '../../styles/organizationCard.module.css'
import type { OrganizationEditSectionProps } from '../../types/components'
import { ORG_FORM_SUBHEADING, SKIP_REIMBURSEMENT_FORM_VARIABLES } from '../../constants/editPage'

export function OrganizationSkipReimbursementTab({ ctx }: OrganizationEditSectionProps) {
  return (
        <div
          id="org-panel-skipreimbursement"
          role="tabpanel"
          aria-labelledby="org-tab-skipreimbursement"
          hidden={ctx.selectedTab !== 'skipreimbursement'}
        >
        <div className="space-y-6">
          <div className={companyFormStyles.card}>
            <div className={companyFormStyles.cardHeader}>
              <FileText className={companyFormStyles.cardIcon} />
              <h2 className={companyFormStyles.cardTitle}>
                Skip Reimbursement Form
              </h2>
            </div>

            <div className={companyFormStyles.cardBody}>
              <div className="space-y-6">
                <div>
                  <p className={ORG_FORM_SUBHEADING} id="org-skip-form-variables-heading">
                    Available Variables:
                  </p>
                  <div
                    className={companyFormStyles.variablesBox}
                    aria-labelledby="org-skip-form-variables-heading"
                    role="list"
                    aria-label="Skip reimbursement template variables"
                  >
                    <div className="flex flex-wrap gap-x-2 gap-y-2">
                      {SKIP_REIMBURSEMENT_FORM_VARIABLES.map((v) => (
                        <code
                          key={v}
                          className={companyFormStyles.variableCode}
                        >
                          {v}
                        </code>
                      ))}
                    </div>
                  </div>
                </div>

                <div className={companyFormStyles.formGroup}>
                  <label className={companyFormStyles.formLabel} htmlFor="org-skip-claim-form">
                    Skip Reimbursement Form Template
                  </label>
                  <Controller
                    name="skip_claim_form"
                    control={ctx.control}
                    render={({ field: { value, onChange } }) => (
                      <CKEditor4 id="org-skip-claim-form" value={value || ''} onChange={onChange} />
                    )}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        </div>

  )
}
